const setGlobalEventListeners = () => {
	window.addEventListener('scroll', () => {
		const scrollTop = window.pageYOffset
            || document.documentElement.scrollTop
            || document.body.scrollTop
            || 0;
		document.body.classList.toggle('is-page-scrolled', Boolean(scrollTop));
		document.body.classList.toggle(
			'is-whole-page-scrolled',
			Boolean(scrollTop > 600),
		);
	});
};

export default setGlobalEventListeners;
